import {ITrainingDialogue} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';

export const SET_TRAINING_DIALOGUES = 'SET_TRAINING_DIALOGUES';
export const setTrainingDialogues = (dialogues: ITrainingDialogue[]): IAction<ITrainingDialogue[]> => ({
  type: SET_TRAINING_DIALOGUES,
  payload: dialogues
});

export const SET_TRAINING_DIALOGUE = 'SET_TRAINING_DIALOGUE';
export const setTrainingDialogue = (dialogue: ITrainingDialogue): IAction<ITrainingDialogue> => ({
  type: SET_TRAINING_DIALOGUE,
  payload: dialogue
});

export const CLEAR_TRAINING_DIALOGUE = 'CLEAR_TRAINING_DIALOGUE';
export const clearTrainingDialogue = (): IAction<null> => ({
  type: CLEAR_TRAINING_DIALOGUE,
  payload: null
});

const trainingsActions = {
  setTrainingDialogues,
  setTrainingDialogue,
  clearTrainingDialogue
};

export type TrainingsActionsType = InferActionsTypes<typeof trainingsActions>;
